import * as Sentry from '@sentry/react';
import { ENVIRONMENT, VERSION, IS_PROD } from '../../../../constants';
import { isZeroSample } from './isZeroSample';

if (IS_PROD) {
  // https://hotjar.sentry.io/projects/engage-unmoderated/?project=4507345169547264
  Sentry.init({
    dsn: 'https://736f81f196f9bf84dba7b22e5754b2fc@o303140.ingest.us.sentry.io/4507345169547264',
    integrations: [Sentry.captureConsoleIntegration()],
    sampleRate: isZeroSample() ? 0.0 : 1.0,
    autoSessionTracking: false,
    release: 'engage-unmoderated@' + VERSION,
    environment: ENVIRONMENT,
    attachStacktrace: true,
    allowUrls: [/https:\/\/.*\.hotjar\.com/],
  });
}
